import React from "react";

import MobileTimelineSelect from "./MobileTimelineSelect";
import ProjectionControls from "./ProjectionControls";
import PlayToggleButton from "./PlayToggleButton";

/**
 * Mobile view renderer for KlimaSlider.
 * Pure composition/layout; does not implement selection/timer rules.
 */
function MobileView({
  playing,
  onTogglePlaying,
  playDisabled,
  sliderItems,
  originalItems,
  displaySelected,
  isChangeMode,
  onPickOriginalIndex,
  projectionControlsDisabled,
  szenarioItems,
  szenarioIndex,
  onScenarioChange,
  onChangeMode,
  // ForecastToggle props
  CommunicationStore,
  token,
  view,
  map,
}) {
  return (
    <div style={{ width: "100%" }}>
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <PlayToggleButton
          playing={playing}
          onToggle={onTogglePlaying}
          mobile
          disabled={playDisabled}
        />
        <div style={{ flex: 1 }}>
          <MobileTimelineSelect
            sliderItems={sliderItems}
            originalItems={originalItems}
            displaySelected={displaySelected}
            isChangeMode={isChangeMode}
            onPickOriginalIndex={onPickOriginalIndex}
          />
        </div>
      </div>

      <ProjectionControls
        disabled={projectionControlsDisabled}
        mobile={true}
        szenarioItems={szenarioItems}
        szenarioIndex={szenarioIndex}
        onScenarioChange={onScenarioChange}
        isChangeMode={isChangeMode}
        onChangeMode={onChangeMode}
        CommunicationStore={CommunicationStore}
        token={token}
        view={view}
        map={map}
      />
    </div>
  );
}

export default MobileView;
